import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import swal from "sweetalert";
import Header from "../../layout/Header";
import Paginated from "../Report/Paginated";
import { getCustomer } from "../../../actions/customer";
import {
    customerView,
    transactionRegistration,
    updateCustomerReceiptData,
    getCustomerReceiptData,
} from "../campaigns/services";
import { getDate } from "../../../utils/helper";
import moment from "moment";

const downloadImage = (e, url) => {
    e.preventDefault();
    e.stopPropagation();
    const link = document.createElement("a");
    link.href = url;
    link.download = url.split("/").pop() || "image";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const Kyc = ({ getCustomer, Customer }) => {
    const location = useLocation();
    const [loader, setLoader] = useState(false);
    const [kycList, setKycList] = useState([]);
    const [cusData, setCusData] = useState([]);
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetch = async () => {
            setLoader(true);
            const tempToken = JSON.parse(localStorage.getItem("token_gen"))?.access_token;
            const id = localStorage.getItem("Id");

            try {
                const [kycData] = await Promise.all([
                    getCustomerReceiptData(tempToken, id),
                    getCustomer(tempToken, id, 1, 10000),
                ]);
                setKycList(kycData?.data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoader(false);
            }
        };

        fetch();
    }, [getCustomer]);

    const getKYCDetails = async () => {
        setLoader(true);
        let tempToken = JSON.parse(localStorage.getItem("token_gen"));
        const res = await getCustomerReceiptData(tempToken?.access_token);
        if (res.message === "Success") {
            setKycList(res?.data);
        }
        setLoader(false);
    };
    useEffect(() => {
        setCusData(Customer?.data);
    }, [Customer]);

    useEffect(() => {
        if (kycList?.length > 0) {
            const tempData = kycList.map((ele) => {
                if (cusData?.data?.data?.length > 0) {
                    const flag = cusData.data.data.find(
                        (cus) => cus.customerData.customercode === ele.customercode
                    );
                    if (flag) {
                        return {
                            ...ele,
                            customername: flag.customerData.name,
                            action: ele,
                            date: getDate(ele.createdAt, "MM-DD-YYYY"),
                            createdAt: ele.createdAt,
                            link: ele.other1?.imageLink,
                        };
                    }
                }
                return ele;
            });
            setData(tempData?.length ? tempData.reverse() : []);
        }
    }, [cusData, location, kycList]);

    const updateKYCDetails = async (token, body) => {
        const res = await updateCustomerReceiptData(token, body);
        if (res.message === "Success") {
            await getKYCDetails();

            swal({
                position: "center",
                icon: "success",
                title: "Request processed successfully.",
                showConfirmButton: false,
                timer: 2000,
            });
        } else {
            swal({
                position: "center",
                icon: "error",
                title: res.message,
                showConfirmButton: false,
                timer: 2000,
            });
        }
    };

    const onSubmit = async (receipt, status) => {
        const { updatedAt, _attachments, action, date, _etag, _rid, _self, _ts, ...rest } = receipt;
        setLoader(true);
        const body = {
            ...rest,
            other1: {
                ...rest.other1,
                status: status,
            },
        };
        const tempToken = JSON.parse(localStorage.getItem("token_gen"));
        const custRes = await customerView(tempToken?.access_token, receipt.customercode);

        const transBody = {
            milestoneActivity: "KYC Complete",
            mobile: custRes.customer.mobile,
            schemacode: "TSC002035",
        };
        const trans24 = {
            milestoneActivity: "KYC in 24hr",
            mobile: custRes.customer.mobile,
            schemacode: "TSC002035",
        };

        if (status === 1) {
            const transactionReg = await transactionRegistration(
                tempToken?.access_token,
                JSON.stringify(transBody)
            );
            if (transactionReg?.message === "Request processed successfully.") {
                const createdDate = moment(custRes?.customer?.createdAt);
                const now = moment.utc();
                const createdAt = moment.utc(createdDate);
                const hoursDiff = now.diff(createdAt, "hours");

                if (hoursDiff >= 0 && hoursDiff <= 24) {
                    await transactionRegistration(tempToken?.access_token, JSON.stringify(trans24));
                }
                await updateKYCDetails(tempToken?.access_token, body);
            } else {
                swal({
                    position: "center",
                    icon: "error",
                    title: transactionReg.message,
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        } else {
            await updateKYCDetails(tempToken?.access_token, body);
        }
        setLoader(false);
    };

    const COLUMNS = [
        {
            Header: "Date",
            Footer: "Date",
            accessor: "date",
            disableFilters: true,
            sticky: "left",
        },
        {
            Header: "Customer Name",
            Footer: "Customer Name",
            accessor: "customername",
        },
        {
            Header: "Review Link",
            Footer: "Review Link",
            accessor: "link",
            Cell: ({ value }) => (
                <div className="d-flex justify-content-center align-items-center">
                    <button
                        className="btn btn-link p-0"
                        onClick={(e) => downloadImage(e, value)}
                    >
                        <i className="fa-solid fa-download"></i>
                    </button>
                </div>
            ),
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: "action",
            Cell: ({ value, row }) => {
                const receipt = row.original;
                return (
                    <div className="d-flex justify-content-between align-items-center">
                        {value?.other1?.status === 0 ? (
                            <div className="d-flex align-items-center gap-2">
                                <button
                                    className="btn btn-link p-0 me-2 text-success"
                                    onClick={() => onSubmit(receipt, 1)}
                                >
                                    Approved
                                </button>
                                <button
                                    className="btn btn-link p-0 text-danger"
                                    onClick={() => onSubmit(receipt, 2)}
                                >
                                    Rejected
                                </button>

                            </div>
                        ) : value?.other1?.status === 1 ? (
                            <button className="btn btn-link p-0 text-success" disabled>
                                Approved
                            </button>
                        ) : value?.other1?.status === 2 ? (
                            <button className="btn btn-link p-0 text-danger" disabled>
                                Rejected
                            </button>
                        ) : null}
                        <div className="ml-2">
                            <Link
                                to={`/customer-view/${value?.customercode}`}
                                state={{
                                    customerCode: value?.customercode,
                                }}
                                className='edit_btn'
                                csvalue='View Details'>
                                <i className='fa-solid fa-eye'></i>View Details
                            </Link>
                        </div>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div><div></div><div></div><div></div>
                        <div></div><div></div><div></div><div></div>
                    </div>
                </div>
            )}

            <Header name={"Verification & Approvals"} />

            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customersCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Verification & Approvals</h4>
                            </div>
                        </div>

                        <div className="dashboard__body">
                            <Paginated data={data || []} columns={COLUMNS} setData={setData} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    Customer: state.Customer,
});

const mapDispatchToProps = {
    getCustomer,
};

export default connect(mapStateToProps, mapDispatchToProps)(Kyc);
